import { Link } from "@tanstack/react-router";
import type { Reportage } from "@/data/reportages";

export function ReportageCard({ item }: { item: Reportage }) {
  return (
    <article className="group border-b border-border py-6">
      <Link to="/reportage/$slug" params={{ slug: item.slug }} className="block">
        <p className="text-[0.6rem] uppercase tracking-[0.3em] text-muted-foreground">
          {item.channel} · {item.program} · {item.year}
        </p>
        <h3 className="mt-2 font-[family-name:var(--font-display)] text-2xl leading-tight transition-colors group-hover:underline underline-offset-4">
          {item.title}
        </h3>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">{item.summary}</p>
        <p className="mt-3 text-[0.65rem] uppercase tracking-[0.2em] text-muted-foreground">
          {item.duration} · {item.places.join(" / ")}
        </p>
      </Link>
    </article>
  );
}